// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"f646e9ea","977":"3072f8e4"}[chunkId] + ".chunk.js";
};